



















import ApiClient from '@/js/api.js'
import PopupTemplate from '@/views/templates/africadogs/PopupTemplate.vue'
import QuizAfricaDogs from '@/views/organisms/QuizAfricaDogs.vue'

export default
  components: {
    PopupTemplate
    QuizAfricaDogs
  }

  data: () ->
    baseColor: '#ECC236'
    point: 0
    mode: 0
    quizResult: 0
    quizData:
      hukidashi: [
        'おすすめのポロシャツは'
        'なんていう染色方法で染められた生地だったっけ？'
      ]
      quiz: [
        'さいけつ染め'
        '重彩染め'
        'ぼかし染め'
      ]
      success_message: [
        'ポロシャツの染色技法は世界的なコレクションブランドでも採用されたこともある「彩纈染め（さいけつぞめ）」です。特殊な割れ模様を表現できる黒糊をつかい、糊が乾いた割れ目に赤・青・黄の3色の塗料を染み込ませて染め上げました。'
      ]
      answer: 1

  methods: {
    closePopup: () ->
      m = @mode
      if m == 0
        m = 2
      @$emit('closePopup', m)
    success: () ->
      @mode = 3
      @quizResult = 2
      @baseColor = '#F699AB'
      api = new ApiClient()
      param =
        'point_code': 'p3-11'
      data = await api.post('/member/point/save', true, param)
      @point = data.point
      if @point > 0
        @$emit('addPoint', @point)
      @$emit('success')
    miss: () ->
      @baseColor = '#7BCAD8'
      @mode = 2
      @quizResult = 1
  }
